// pages/Services.js
import React from "react";
import Header from "../components/home/Header";
import BlogMain from "../components/Blog/BlogMain";
import Footer from "../components/home/Footer";
import { NewOurWork } from "../components/ourwork/NewOurWork";

function BlogMainPage() {
  return (
    <div>
      <Header />
      <BlogMain />
      {/* <div style={{height:'65vh',display:'flex',justifyContent:'center',alignContent:'center'}}>
      <p style={{textAlign:'center',fontSize:'50px'}}>Comming Soon...</p>
      </div> */}
      {/* <NewOurWork /> */}
      <Footer />
    </div>
  );
}

export default BlogMainPage;

// content: {
//   sections: Array(12);
// }
// created_at: "2025-07-03T05:50:58.955432";
// description: "An in-depth exploration of Python's history, capabilities, and best practices to help you master the world's most popular programming language.";
// id: 41;
// image_url: "/assets/blog/python-image-1.jpg";
// slug: "mastering-python";
// title: "Mastering Python: A Complete Guide to Becoming a Proficient Developer";

// Array : {text: 'Python has emerged as the most versatile and begin…to help you become a proficient Python developer.', heading: 'Introduction: Why Python?'}
